import * as React from 'react';

import { Logo, P1 } from '@bumble/ui-kit';
import Image from 'lib/image-container';

import AppLinks from 'components/app-links/app-links';
const backgroundImg = '/project-love/assets/bff-coming-soon-background.jpg';

export const BFFComingSoonHeroBlockContainer: React.FC = () => {
  return (
    <section className="bff-coming-soon-hero">
      <div className="bff-coming-soon-hero__media">
        <Image
          src={backgroundImg}
          alt=""
          fill={true}
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
        />
      </div>
      <div className="bff-coming-soon-hero__background-overlay"></div>
      <div className="bff-coming-soon-hero__content">
        <div className="bff-coming-soon-hero__logo_and_text">
          <h1 className="bff-coming-soon-hero__logo">
            <Logo variant="bff" color="custom" customColor="#fff28e" />
          </h1>
          <div className="bff-coming-soon-hero__text">
            <P1 color="inverse" align="center">
              We’ve reimagined BFF to make finding your people easier, safer, and more fun. Whether
              you’re settling into a new city, starting college, or just looking for friends who get
              you, our latest features are built to help. This page will update soon with everything
              you need to know.
            </P1>
          </div>
        </div>

        <div className="bff-coming-soon-hero__buttons">
          <AppLinks
            appStoreLink="https://apps.apple.com/us/app/geneva/id1478573199"
            googleStoreLink="https://play.google.com/store/apps/details?id=com.genevachat.prod"
            description="Apple and the Apple Logo are trademarks of Apple Inc.<br/>Google Play is a trademark of Google LLC."
            isTextCenter={true}
          />
        </div>
      </div>
    </section>
  );
};
